import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getUserTypeSelector } from 'src/store/app';

import { ROUTE } from 'src/constants/routes';

import { Button } from '../Button/Button';

import CheckedPurpleCircle from 'src/assets/app/checkedPurpleCircle.svg';
import classes from './brokerPricing.module.scss';

const features = [
  'Reply to any invited RFP',
  'Track your reply and win rates',
  'Medical',
  'Dental',
  'Vision',
  'Life',
  'Disability',
  'Accident',
  'Hospital',
  'Critical Illness',
  'RFP underwriting exports',
  'Instant web based proposals',
  'Broker deal room chat access *coming soon',
  'Search for new broker RFPs',
  'Reporting',
  'Unlimited Team Users',
  'Team Workflows',
  'Deal recommendations *coming soon',
  'Deal loss alerts *coming soon',
];

export const BrokerPricing = (props) => {
  const { isAgency = false } = props;

  const navigate = useNavigate();
  const userType = useSelector(getUserTypeSelector);

  const onClickGetStarted = useCallback(() => {
    if (userType) {
      navigate(ROUTE.BROKER);
    } else {
      navigate(ROUTE.SIGNUP);
    }
  }, [navigate, userType]);

  return (
    <div className={classes.BrokerPricing}>
      {/* Main Header Section */}
      <div className={classes.BrokerPricingHeader}>
        <h1>Free for Brokers, Free for Employers, Free for Employees</h1>
        <p className={classes.BrokerPricingSubheader}>
          The Monark Platform is Free to brokers to provide to their Employers, but we have a "use it or lose it approach"
        </p>
      </div>

      {/* Pricing Terms Section */}
      <div className={classes.BrokerPricingTerms}>
        <div className={classes.BrokerPricingTermsCard}>
          <h3>Getting Started</h3>
          <ul>
            <li>Brokers can quote their first 3 groups for free</li>
            <li>Maintain an average of at least 1 group quote per month for the first year</li>
            <li>After the first year, maintain at least 12 active groups utilizing Monark's set of preferred carriers</li>
          </ul>
        </div>
        
        <div className={classes.BrokerPricingTermsCard}>
          <h3>Revenue Sharing</h3>
          <ul>
            <li>Employee decision support: 40% revenue share on incremental commission over a specified threshold</li>
            <li>Client leads from Monark: 20% revenue share on accepted leads</li>
          </ul>
        </div>

        <div className={classes.BrokerPricingTermsCard}>
          <h3>Platform Fee</h3>
          <p className={classes.BrokerPricingTermsHighlight}>
            We hope you never need to pay it!
          </p>
          <p>$50 per user per month for brokers who do not maintain the group thresholds</p>
        </div>
      </div>

      {/* Get Started CTA */}
      {!isAgency && (
        <div className={classes.BrokerPricingCTA}>
          <Button title="Get Started" type="primary" onClick={onClickGetStarted} />
        </div>
      )}

      {/* Features Section */}
      <div className={classes.BrokerPricingFeatures}>
        <h2>All Features Included</h2>
        <div className={classes.BrokerPricingFeaturesGrid}>
          {features.map((feature) => (
            <div key={feature} className={classes.BrokerPricingFeaturesItem}>
              <img src={CheckedPurpleCircle} alt="Check" />
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
